"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _noop = _interopRequireDefault(require("lodash/noop"));
var _reactResizeDetector = _interopRequireDefault(require("react-resize-detector"));
var _scroll = require("../utils/scroll");
var _styles = require("./styles");
var _excluded = ["children", "index", "isOverflowing", "onIndexChange"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var Carousel = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Carousel, _React$Component);
  var _super = _createSuper(Carousel);
  function Carousel() {
    var _this;
    (0, _classCallCheck2["default"])(this, Carousel);
    _this = _super.call(this);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setSize", function () {
      var wrapperNode = _this.wrapper.current;
      var sliderNode = _this.slider.current;
      if (wrapperNode && wrapperNode.style && sliderNode && sliderNode.style) {
        wrapperNode.style.height = sliderNode.style.height;
        _this.scrollPosition();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "scrollRight", function (event) {
      event.stopPropagation();
      var target = _this.slider.current;
      var width = target.offsetWidth + target.scrollLeft;
      var childWidth = 0;
      for (var i = 0; i < target.children.length; i += 1) {
        var child = target.children[i];
        childWidth += child.offsetWidth;
        var isLast = target.children.length === i + 1;
        if (isLast || childWidth > width) {
          _this.props.onIndexChange(i - 1);
          (0, _scroll.horizScrollToElement)(target, child, _this.props.oneItemPerSlide ? 1 : 0.55);
          return;
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "scrollLeft", function (event) {
      event.stopPropagation();
      var target = _this.slider.current;
      var scrollRight = target.scrollWidth - target.scrollLeft - target.offsetWidth;
      var width = target.offsetWidth + scrollRight;
      var children = (0, _toConsumableArray2["default"])(target.children).reverse();
      var childWidth = 0;
      for (var i = 0; i < children.length; i += 1) {
        var child = children[i];
        childWidth += child.offsetWidth;
        var isLast = children.length === i + 1;
        if (isLast || childWidth > width) {
          _this.props.onIndexChange(children.length - (i + 2));
          (0, _scroll.horizScrollToElement)(target, child, _this.props.oneItemPerSlide ? 1 : 0.45);
          return;
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "scrollToIndex", function (index) {
      var target = _this.slider.current;
      if (!target.children) {
        return;
      }
      if (index >= 0 && index < target.children.length) {
        (0, _scroll.horizScrollToElement)(target, target.children[index], _this.props.oneItemPerSlide ? 0 : 0.5);
      }
    });
    _this.state = {
      atLeft: true,
      atRight: false
    };
    _this.slider = /*#__PURE__*/_react["default"].createRef();
    _this.wrapper = /*#__PURE__*/_react["default"].createRef();
    _this.scrollPosition = _this.scrollPosition.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  (0, _createClass2["default"])(Carousel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setSize();
      window.addEventListener('resize', this.setSize);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var isOverflow = !this.state.atLeft || !this.state.atRight;
      this.props.isOverflowing(isOverflow);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.setSize);
    }
  }, {
    key: "setAtLeft",
    value: function setAtLeft(atLeft) {
      if (atLeft !== this.state.atLeft) {
        this.setState({
          atLeft: atLeft
        });
      }
    }
  }, {
    key: "setAtRight",
    value: function setAtRight(atRight) {
      if (atRight !== this.state.atRight) {
        this.setState({
          atRight: atRight
        });
      }
    }
  }, {
    key: "scrollPosition",
    value: function scrollPosition() {
      var target = this.slider.current;
      var scrollLeft = target.scrollLeft,
        scrollWidth = target.scrollWidth;
      var scrollRight = Math.max(0, scrollWidth - scrollLeft - Math.ceil(target.getBoundingClientRect().width));
      this.setAtLeft(scrollLeft === 0);
      this.setAtRight(scrollRight === 0);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        atLeft = _this$state.atLeft,
        atRight = _this$state.atRight;
      var _this$props = this.props,
        children = _this$props.children,
        index = _this$props.index,
        isOverflowing = _this$props.isOverflowing,
        onIndexChange = _this$props.onIndexChange,
        rest = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      return /*#__PURE__*/_react["default"].createElement(_styles.Wrapper, (0, _extends2["default"])({}, rest, {
        ref: this.wrapper
      }), !atLeft && /*#__PURE__*/_react["default"].createElement("div", null, !this.props.oneItemPerSlide && /*#__PURE__*/_react["default"].createElement(_styles.GradientLeft, null), /*#__PURE__*/_react["default"].createElement(_styles.LeftArrowBox, {
        oneItemPerSlide: this.props.oneItemPerSlide,
        onClick: this.scrollLeft
      }, /*#__PURE__*/_react["default"].createElement(_styles.ArrowWrapper, null, /*#__PURE__*/_react["default"].createElement(_styles.LeftScrollArrow, null)))), /*#__PURE__*/_react["default"].createElement(_styles.Slider, {
        ref: this.slider,
        onScroll: this.scrollPosition,
        sliderMarginBottom: this.props.sliderMarginBottom
      }, /*#__PURE__*/_react["default"].createElement(_reactResizeDetector["default"], {
        handleWidth: true,
        handleHeight: true,
        onResize: this.setSize
      }), children), !atRight && /*#__PURE__*/_react["default"].createElement("div", null, !this.props.oneItemPerSlide && /*#__PURE__*/_react["default"].createElement(_styles.GradientRight, null), /*#__PURE__*/_react["default"].createElement(_styles.RightArrowBox, {
        oneItemPerSlide: this.props.oneItemPerSlide,
        onClick: this.scrollRight
      }, /*#__PURE__*/_react["default"].createElement(_styles.ArrowWrapper, null, /*#__PURE__*/_react["default"].createElement(_styles.RightScrollArrow, null)))));
    }
  }]);
  return Carousel;
}(_react["default"].Component);
Carousel.propTypes = {
  children: _propTypes["default"].node,
  isOverflowing: _propTypes["default"].func,
  onIndexChange: _propTypes["default"].func,
  index: _propTypes["default"].number,
  oneItemPerSlide: _propTypes["default"].bool,
  sliderMarginBottom: _propTypes["default"].string
};
Carousel.defaultProps = {
  children: [],
  isOverflowing: _noop["default"],
  onIndexChange: _noop["default"],
  index: 0,
  oneItemPerSlide: false,
  sliderMarginBottom: '-20px'
};
var _default = Carousel;
exports["default"] = _default;
//# sourceMappingURL=Carousel.js.map